<template>
  <v-container>
    <h1>Usuarios</h1>
    <v-row class="ma-0">
      <v-spacer></v-spacer>
      <v-col class="pa-0 mb-4" style="display: flex; justify-content: flex-end;">
        <v-btn
          color="black" 
          elevation="8"
          @click="dialogCreateUser = true"
          class="white--text my-2 mr-2"
          style="border-radius: 36px; border: 2px solid black; font-family: 'montserrat-semibold'; text-transform: none;"
          :disabled="!permissionList.includes('createUser')"
        >
          {{ "Crear usuario" }}
        </v-btn>
        <v-btn
          color="black" 
          elevation="8" 
          class="white--text my-2"
          style="border-radius: 36px; border: 2px solid black; font-family: 'montserrat-semibold'; text-transform: none;" 
        >
          <v-img class="mr-2" src="../../assets/icons/Vector.svg" style="width: 14px;"></v-img>
          {{ "Descargar" }}
        </v-btn>
      </v-col>
    </v-row>
    <v-skeleton-loader type="table" v-if="isLoadingTable" />
    <v-data-table class="d-none d-sm-block" v-else :items-per-page="10" hide-default-header :items="users" style="background-color: white !important">
      <template v-slot:header="{ props }">
        <thead style="background-color: #f9fafd;">
          <tr>
            <th class="header__title left">{{ "User" }}</th>  
            <th class="header__title center">{{ 'Email' }}</th>
            <th class="header__title center">{{ 'Status' }}</th>
            <th class="header__title right">{{ 'Acciones' }}</th> 
          </tr>
        </thead>
      </template>
      <template v-slot:body="{ items }">
        <tbody style="background: #f9fafd;">
          <tr v-for="item in items" :key="item.id">
            <td class="table__item">{{ item.sName + " " + item.sLastname }}</td>
            <td class="table__item">{{ item.sEmail ? item.sEmail : "-" }}</td>
            <td class="table__item">{{ item.bActive ? "Active" : "Inactive" }}</td>
            <td class="table__item">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn @click="openDetail(item)" :disabled="true" v-bind="attrs" v-on="on" icon color="black">
                    <v-icon>mdi-pencil-outline</v-icon>
                  </v-btn>
                </template>
                <span>Edit</span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn @click="openDetail(item)" :disabled="true" v-bind="attrs" v-on="on" icon color="red">
                    <v-icon>mdi-delete-outline</v-icon>
                  </v-btn>
                </template>
                <span>Delete</span>
              </v-tooltip>
            </td>
          </tr>
        </tbody>
      </template>
    </v-data-table>
    <v-dialog v-model="dialogCreateUser" v-if="dialogCreateUser" max-width="600px" persistent>
      <v-card>
        <v-container class="mt-1" style="max-width: 600px">
          <v-card-title
            class="pa-0"
            style="
              display: flex;
              text-align: center;
              justify-content: center;
            "
          >
            <span class="title font-weight-bold text-textblack">
              {{ "Agregar usuario" }}
            </span>
          </v-card-title>
          <v-card-text class="py-6 px-4">
            <v-form
              ref="userForm"
              v-model="userFormValid"
              autocomplete="off"
            >
              <v-row>
                <v-col cols="12" sm="6">
                  <v-text-field
                    v-model="userForm.sName"
                    :disabled="isLoading"
                    :label="'Nombre'"
                    :rules="nameRules"
                    style="border-radius: 10px"
                    required
                    outlined
                    hide-details
                    autocomplete="off"
                    name="newUserName"
                  />
                </v-col>
                <v-col cols="12" sm="6">
                  <v-text-field
                    v-model="userForm.sLastname"
                    :label="'Apellido'"
                    :disabled="isLoading"
                    :rules="lastnameRules"
                    style="border-radius: 10px"
                    required
                    outlined
                    hide-details
                    autocomplete="off"
                    name="newUserLastname"
                  />
                </v-col>
                <v-col cols="12" sm="12">
                  <v-text-field
                    v-model="userForm.sEmail"
                    :disabled="isLoading"
                    :label="'Correo electrónico'"
                    :rules="emailRules"
                    style="border-radius: 10px"
                    required
                    outlined
                    hide-details
                    autocomplete="off"
                    name="newUserEmail"
                  />
                </v-col>
                <v-col cols="12" sm="12">
                  <v-text-field
                    v-model="userForm.sPassword"
                    :disabled="isLoading"
                    :label="'Contraseña'"
                    style="border-radius: 10px"
                    :rules="passwordRules"
                    :type="showUserPassword ? 'text' : 'password'"
                    required
                    outlined
                    hide-details
                    autocomplete="new-password"
                    name="newUserPassword"
                    :append-icon="
                      showUserPassword ? 'mdi-eye' : 'mdi-eye-off'
                    "
                    @click:append="showUserPassword = !showUserPassword"
                  />
                </v-col>
                <v-col cols="12" sm="12">
                  <v-text-field
                    v-model="userForm.sConfirmPassword"
                    :disabled="isLoading"
                    :label="'Confirmar contraseña'"
                    style="border-radius: 10px"
                    :rules="confirmPasswordRules"
                    :type="showUserPassword ? 'text' : 'password'"
                    required
                    outlined
                    hide-details
                    autocomplete="new-password"
                    name="newUserConfirmPassword"
                    :append-icon="
                      showUserPassword ? 'mdi-eye' : 'mdi-eye-off'
                    "
                    @click:append="showUserPassword = !showUserPassword"
                  />
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
          <v-card-actions
            class="mt-5"
            style="justify-content: space-evenly"
          >
            <v-btn
              elevation="4"
              class="mr-2 px-10"
              style="
                color: black;
                border-radius: 36px;
                border: 2px solid black;
                background-color: #fff;
                font-family: 'montserrat-semibold';
                text-transform: none;
              "
              outlined
              :disabled="isLoading"
              @click="dialogCreateUser = false; otp = '', userForm = { sName: '', sLastname: '', sEmail: '', sPassword: '', sConfirmPassword: '' }"
            >
              {{ "Cancelar" }}
            </v-btn>
            <v-btn
              color="black"
              elevation="4"
              class="white--text px-10"
              style="
                border-radius: 36px;
                font-family: 'montserrat-semibold';
                text-transform: none;
              "
              :disabled="userForm.sName === '' || userForm.sLastname === '' || userForm.sEmail === '' || userForm.sPassword === '' || userForm.sConfirmPassword === '' || isLoading"
              @click="createUser()"
            >
              {{ "Crear" }}
            </v-btn>
          </v-card-actions>
        </v-container>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
  import moment from "moment";
  export default {
    name: "Ingresos",
    props: {
      activeTab: String,
      permissionList: Array,
      enterprise: Object
    },
    data() {
      return {
        users: [],
        isLoading: false,
        isLoadingTable: false,
        dialogRequestPayment: false,
        forward: null,
        dialogCreateUser: false,
        showUserPassword: false,
        userFormValid: false,
        userForm: {
          sName: "",
          sLastname: "",
          sEmail: "",
          sPassword: "",
          sConfirmPassword: ""
        },
      };
    },
    watch: {
      activeTab(val) {
        if (val === 'users') {
          this.getUsers();
        }
      }
    },
    computed: {
      nameRules() {
        return [(v) => !!v || ''];
      },
      lastnameRules() {
        return [(v) => !!v || ''];
      },
      passwordRules() {
        return [
          (v) => !!v || '',
          (v) => v.length >= 6 || '',
          (v) =>
            /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~`]/.test(v) || ''
        ];
      },
      confirmPasswordRules() {
        return [
          (v) => !!v || '',
          (v) => {
            const form = this.userForm;
            return v === form.sPassword || '';
          }
        ];
      },
      emailRules() {
        return [
          (v) => !!v || '',
          (v) => /.+@.+\..+/.test(v) || ''
        ];
      },
    },
    mounted() {
      if (this.activeTab === 'users') {
        this.getUsers();
      }
    },
    methods: {
      getUsers() {
        this.isLoadingTable = true;
        this.users = [];
        const payload = {
          sEnterpriseId: this.$route.params.sEnterpriseId,
        };

        DB.post(`${URI}/api/v1/en/administrator/users`, payload, {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : ""
          }
        })
        .then((response) => {
          this.users = response.data.users;
          this.isLoadingTable = false;
        }).catch((error) => {
          this.isLoadingTable = false;
          this.mixError(error.response.data.message, error.response.status);
        });
      },
      formatMoney(value) {
        let multiplied = value * 100;
        let rounded = Math.round(multiplied);
        let formattedNumber = rounded / 100;
        // Si el valor es -0, lo convertimos a 0
        if (Object.is(formattedNumber, -0)) {
          formattedNumber = 0;
        }
        return new Intl.NumberFormat("en-US", {
          style: "decimal",
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }).format(formattedNumber);
      },
      formatDate: function (date) {
        if (this.selectLanguage === "sp") {
          moment.locale("es");
        } else {
          moment.locale("en");
        }
        let newDate = moment(date);
        let formattedDate = newDate.format("MMMM DD, YYYY HH:mm a");
        return formattedDate;
      },
      async createUser() {
        this.isLoading = true;
        if (!this.userForm.sName || !this.userForm.sLastname || !this.userForm.sEmail || !this.userForm.sPassword || this.userForm.sPassword !== this.userForm.sConfirmPassword) {
          this.mixError(
            "Completa todos los campos y asegúrate que las contraseñas coincidan"
          );
          return;
        }
        const payload = {
          sEnterpriseId: this.$route.params.sEnterpriseId,
          sName: this.userForm.sName,
          sLastname: this.userForm.sLastname,
          sEmail: this.userForm.sEmail,
          sPassword: this.userForm.sPassword
        };

        DB.post(`${URI}/api/v1/en/administrator/createUser`, payload, {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : ""
          }
        })
        .then((response) => {
          this.getUsers();
          this.dialogCreateUser = false;
          this.userForm = {
            sName: "",
            sLastname: "",
            sEmail: "",
            sPassword: "",
            sConfirmPassword: ""
          };
          this.isLoading = false;
        }).catch((error) => {
          this.isLoading = false;
          this.mixError(error.response.data.message, error.response.status);
        });
      },
    }
  };
</script>
<style scoped>
</style>